<ion-content>
  <div class="content">
    <div class="box">
      <div class="header">
        <div class="img-header">
          <img src="assets/app-att.svg" alt="Imagem nova versão">
        </div>
      </div>
      <div class="body">
        <h1>O Monitorar Cidadão tem uma nova atualização para você.</h1>
        <p>Você pode acessar o link da loja abaixo para atualizar o aplicativo.</p>
      </div>
      <div class="footer">
        <ion-button fill="solid" expand="block" color="primary" (click)="abrirLoja()">
          {{ isHybrid ? 'Ir para a loja' : 'Atualizar' }}
        </ion-button>
      </div>
    </div>
  </div>
</ion-content>
